import {autorun} from 'mobx';

import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {USER_SELECTIONS_MANAGER_ACTIONS, UserSelectionsManager} from "../../../core/managers/user-selections.manager";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {UserSelectionModel} from "../../../core/models/user-selection.model";
import {WEBSITE_MODULE} from "../website-module.consts";
import {WebsiteModuleController} from "../website-module.controller";
import {WebsiteModuleState} from "../models/website-module.state";
import {APP} from "../../../core/app/consts";
import {ACTION_TYPES} from "../../../core/consts";
import {SelectionEntityModel} from "../../../infrastructure/models/selection-entity.model";

export class WebsiteModuleUserSelectionToasterHandler extends ActionHandler {
  type = WEBSITE_MODULE.ACTION_TYPES.userSelectionToaster;
  controller: WebsiteModuleController;
  state: WebsiteModuleState;
  timeoutId: Number;

  static injectables = [...BaseComponentLifecycleEventHandler.injectables, UserSelectionsManager];

  constructor(userSelectionsManager: UserSelectionsManager) {
    super();

    this.userSelectionsManager = userSelectionsManager;
    this.timeoutId = null;
  }

  onInitialized(controller: WebsiteModuleController) {
    super.onInitialized(controller);

    this.userSelectionsManager.lastUserSelection = null;
    autorun(() => this.handleUserSelection(this.userSelectionsManager.lastUserSelection));
  }

  action(params) {
    const isAdded: Boolean = this.userSelectionsManager.lastUserSelection.action === USER_SELECTIONS_MANAGER_ACTIONS.add;
    const lastEntity: SelectionEntityModel = this.userSelectionsManager.lastUserSelection.entity;

    if (isAdded) {
      this.userSelectionsManager.remove(lastEntity);
      this.handleEvent(lastEntity, APP.ANALYTICS.UNDO_CLICK_STATUS.undoSelect);
    } else {
      this.userSelectionsManager.add(lastEntity);
      this.handleEvent(lastEntity, APP.ANALYTICS.UNDO_CLICK_STATUS.undoUnselect);
    }

    clearTimeout(this.timeoutId);
  }

  handleUserSelection(selection: UserSelectionModel) {
    if(!selection) {
      return;
    }

    const validBySource: Boolean = ![APP.ANALYTICS.SOURCES.wizard].includes(selection?.source);

    if (validBySource) {
      clearTimeout(this.timeoutId);
      this.state.lastUserSelection = selection;
      this.timeoutId = setTimeout(() => this.state.lastUserSelection = null, this.state.config.lastSelectionUndoDuration);
    }
  }

  handleEvent(entity: SelectionEntityModel, status: APP.ANALYTICS.UNDO_CLICK_STATUS) {
    const sendParams = {
      entityId: entity.id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[entity.type],
      currentLinkModelName: this.state.currentLinkModel?.name,
      status,
    }

    this.controller.action(ACTION_TYPES.undoClick, sendParams)
  }
}
